import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

$(document).ready(function() {
  $('.related-color-products .related-value-wrapper').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    rows: 0,
    responsive: [
      {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
      }
    ]
  });


mobileOnlySlider(".product-single__images-group", false, true, 767);
function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: $arrows,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick"
      }
    ]
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
} // Mobile Only Slider

  //slick slider
  //
  var _slick = false;
  var _is_sliding = false;
  
  //

  var pswpElement = document.querySelectorAll('.pswp')[0];

  var gallery;
  var items = [];
  var images = $('.product-single__images--wrapper .zoom__img');

  if(!images.length) {
      return;
  }
});
